<template>
  <v-row>
    <v-col cols="12" lg="6" v-if="organization">
      <v-card>
        <v-app-bar
          flat
          color="primary"
          dark>
          <v-toolbar-title>{{ organization.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="editMode = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-app-bar>        
        <v-card-text>
          <v-simple-table v-if="organization && !editMode">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>{{ organization.name }}</td>
                </tr>
                <tr>
                  <td>Parent organization</td>
                  <td>{{getOrganizationName(organization.parentOrganizationId)}}</td>
                </tr>
                <tr>
                  <td>Profile</td>
                  <td>{{getProfileName(organization.profileId)}}</td>
                </tr>
                <tr v-for="field in organization.fields" :key="field.id">
                  <td>{{field.name}}</td>
                  <td>{{field.value}}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <organizationForm
            v-if="editMode"
            :me="me"
            :organization="organization"
            :organizations="organizations"
            :organizationProfiles="organizationProfiles"
            v-on:done="getOrganization()"
          ></organizationForm>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" v-if="organization && organization.id != '00000000-0000-0000-0000-000000000000'">
      <organizationUserList
        :organization="organization"
        :organizations="organizations"
        :me="me"
      ></organizationUserList>
    </v-col>
  </v-row> 
</template>

<script>
import organizationForm from "../components/OrganizationForm.vue";
import organizationUserList from "../components/OrganizationUserList.vue";
export default {
  components: {
    organizationForm,
    organizationUserList
  },
  props: ["me", "organizationId"],
  data: () => ({
    editMode: false,
    organization: null,
    organizations: [],
    organizationProfiles: [],
  }),
  watch: {
    '$route.params.organizationId': function() {
      this.getOrganization();
    }
  },
  methods: {
    getOrganizationName(id) {
      var match = this.organizations.find(x => x.id === id);
      return match ? match.name : '';
    },
    getProfileName(id) {
      var match = this.organizationProfiles.find(x => x.id === id);
      return match ? match.name : '';
    },
    getOrganization() {
      if (this.$route.params.organizationId == '00000000-0000-0000-0000-000000000000') {
            this.editMode = true;
            this.organization = {
              id: '00000000-0000-0000-0000-000000000000',
              fields: []
            };
      } else {
        this.editMode = false;
        this.$http
          .get("api/organizations/" + this.organizationId)
          .then(request => {
            this.organization = request.data;
          })
          .catch(e => {
            this.$root.$children[0].$emit("display-error", "1700", e);
          });
      }
    },
    getOrganizations() {
      this.$http
        .get("api/organizations/")
        .then(request => {
          this.organizations = request.data;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1701", e);
        });
    },
    getOrganizationProfiles() {
      this.$http
        .get("api/organizationprofiles/")
        .then(request => {
          this.organizationProfiles = request.data;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1702", e);
        });
    }
  },
  mounted: function() {
    this.getOrganization();
    this.getOrganizations();
    this.getOrganizationProfiles();
  }
};
</script>